import React from 'react';
import './App.scss';
import '@wix/design-system/styles.global.css';
import Display from './components/Display';
import { FirebaseAppProvider, FirestoreProvider } from 'reactfire';
import googleFirebaseConfig from './utils/firebaseConfig';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import Dashboard from './components/Dashboard';
import { initializeApp } from 'firebase/app';
import { SettingsNavigationProvider } from './context/SettingsContext';

function ContentApp() {
  if (window.location.pathname === '/settings') {
    return <SettingsNavigationProvider />
  }
  if (window.location.pathname === '/dashboard') {
    return <Dashboard />
  }

  return <Display />
}

const firebaseApp = initializeApp(googleFirebaseConfig);
const firestore = getFirestore(firebaseApp);
const useEmulators = process.env.REACT_APP_USE_EMULATORS || false;

if (useEmulators) {
  console.log('Connecting to emulators');
  connectFirestoreEmulator(firestore, 'localhost', 8080);
}

function App() {
  return <FirebaseAppProvider firebaseConfig={googleFirebaseConfig}>
    <FirestoreProvider sdk={firestore}>
      <ContentApp />
    </FirestoreProvider>
  </FirebaseAppProvider>
}

export default App;
